import { type RefObject, useEffect } from 'react';

import { eventBus, EventFactory } from '../eventBus';

export function useCashierHeightObserver(
  containerRef: RefObject<HTMLElement | null>,
): void {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    let debounceTimer: ReturnType<typeof setTimeout> | undefined;
    let lastHeight: number | undefined;

    const scheduleHeightUpdate = () => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const height = container.scrollHeight;
        if (!height || height === lastHeight) {
          return;
        }

        lastHeight = height;
        eventBus.emit(EventFactory.changeCashierHeight(height));
      }, 100);
    };

    const resizeObserver = new ResizeObserver(scheduleHeightUpdate);
    resizeObserver.observe(container);
    scheduleHeightUpdate();

    return () => {
      resizeObserver.disconnect();
      clearTimeout(debounceTimer);
    };
  }, [containerRef]);
}
